import React from "react";

const PartnersAndClients = () => {
  // Apne 5 real logo URLs yahan daal do (white/transparent PNG best)
  const clients = [
    { logo: "https://watersprint.io/RTL%20imgs/FCDO.svg" },
    { logo: "https://watersprint.io/RTL%20imgs/UN.png" },
    { logo: "https://watersprint.io/Selected_Logos%202/wwf%20logo.png" },
    { logo: "https://watersprint.io/RTL%20imgs/wb.png" },
    { logo: "https://watersprint.io/RTL%20imgs/UNICEF.png" },
  ];

  return (
    <div
      style={{
        padding: "60px 20px",
        background: "#f8fffc",
        fontFamily: "'Inter', sans-serif",
        textAlign: "left",
      }}
    >
      {/* Heading */}
      <h2
        style={{
          fontSize: "2.5rem",
          fontWeight: "bold",
          color: "#111827",
          marginBottom: "3.5rem",
          position: "relative",
        }}
      >
        Our Clients and partners
        <span
          style={{
            content: "''",
            display: "block",
            width: "80px",
            height: "4px",
            // background: "#14B88F",
            margin: "12px auto 0",
            borderRadius: "2px",
          }}
        ></span>
      </h2>

      {/* 5 Green Logo Boxes */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: 12,
          flexWrap: "wrap",
          // maxWidth: "1200px",
          // maxheight: "1200px",
          margin: "0 auto",
        }}
      >
        {clients.map((client, index) => (
          <div
            key={index}
            style={{
              background:
                index === 0
                  ? "#1A3C34"
                  : index === 1
                  ? "#0F4C3A"
                  : index === 2
                  ? "#2E5D50"
                  : index === 3
                  ? "#3A6B5A"
                  : "#1A3C34",
              borderRadius: 8,
              padding: "2.5rem",
              width: 176,
              height: 176,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              // boxShadow: "0 10px 30px rgba(0,0,0,0.0)",
              transition: "all 0.4s ease",
              cursor: "pointer",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.transform = "translateY(-10px)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.transform = "translateY(0)")
            }
          >
            {/* Sirf Logo – No Text */}
            <img
              src={client.logo}
              alt="Client logo"
              style={{
                width: "80px",
                height: "80px",
                objectFit: "contain",
                filter: "brightness(0) invert(1)", // Dark logo → White
              }}
            />
          </div>
        ))}
      </div>

      {/* Responsive */}
      <style jsx>{`
        @media (max-width: 768px) {
          div[style*="gap: 2.5rem"] {
            gap: 1.5rem !important;
          }
          div[style*="width: 200px"] {
            width: 160px !important;
            height: 160px !important;
            padding: 2rem !important;
          }
          img[style*="width: 80px"] {
            width: 70px !important;
            height: 70px !important;
          }
          h2 {
            font-size: 2rem !important;
          }
        }
        @media (max-width: 480px) {
          div[style*="gap: 2.5rem"] {
            flex-direction: column;
            align-items: center;
          }
          div[style*="width: 200px"] {
            width: 80% !important;
            max-width: 280px !important;
            height: 140px !important;
          }
          img[style*="width: 80px"] {
            width: 60px !important;
            height: 60px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default PartnersAndClients;